const EMPTY = {}

export default store => store || EMPTY;